import script from "./PageTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTwo.vue?vue&type=script&setup=true&lang=js"

import "./PageTwo.vue?vue&type=style&index=0&id=0b6b6d7b&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/qc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b6b6d7b"]])

export default __exports__